import { TextField, useTranslate, FunctionField } from "react-admin";
import * as User from "providers/user";
import CustomList from "./CustomList";
import ListDotsActions from "./ListDotsActions";
import { Link } from "react-router-dom";
import { ListItemButton, Theme, useMediaQuery } from "@mui/material";
import CustomDataGrid from "./CustomDataGrid";
import { EmptyLocationIcon } from "assets/Icons";
import { CustomButton } from "./CustomButton";

export default function LocationList() {
  const { user, permissions } = User.useUser();
  const translate = useTranslate();
  const isSmall = useMediaQuery<Theme>("(max-width:800px)");

  const filter = {
    company_id: permissions.isArtist
      ? user?.joined_company_id
      : permissions.companyId
  };

  return (
    <CustomList
      filter={filter}
      title={translate("pagenames.locations")}
      resource="Location"
      emptyIcon={<EmptyLocationIcon />}
      emptyTitle={translate("empty_list.no_locations_yet")}
      createButtonText={translate("empty_list.add_a_location")}
      emptyListCreateSubtitle={translate("empty_list.do_you_want_to_add_one")}
    >
      <CustomDataGrid bulkActionButtons={false}>
        <TextField
          source="name"
          label={translate("locations.name")}
          data-label={translate("locations.name") + ":"}
          sx={{ marginTop: "6px" }}
        />
        <TextField
          source="nickname"
          label={translate("locations.nickname")}
          data-label={translate("locations.nickname") + ":"}
          emptyText="-"
        />
        {!isSmall && !permissions.isArtist && (
          <FunctionField
            render={(record: any) => (
              <ListDotsActions>
                <Link to={`/dashboard/Location/${record?.id}`}>
                  <ListItemButton
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Inter",
                      "& .MuiListItemButton-root": {
                        fontSize: "14px",
                        fontFamily: "Inter"
                      }
                    }}
                  >
                    {translate("common.edit")}
                  </ListItemButton>
                </Link>
              </ListDotsActions>
            )}
          />
        )}
        {isSmall && (
          <FunctionField
            render={(record: any) => (
              <Link
                to={`/dashboard/Location/${record?.id}/show`}
                style={{
                  width: "100%",
                  marginBottom: "10px"
                }}
              >
                <CustomButton
                  variant="secondary"
                  text={translate("common.view_details")}
                  sx={{ width: "100%" }}
                />
              </Link>
            )}
          />
        )}
      </CustomDataGrid>
    </CustomList>
  );
}
